import { useSelector } from 'react-redux';
import useExperimentalFeature from './useExperimentalFeature';

/**
 * Custom hook to access user preferences from Redux store
 * @returns {object} User preferences - frequentPassengers
 * @returns {Array} returns.frequentPassengers - List of frequent passengers
 */
const useUserPreferences = () => {
  const showFrequentPassengers = useExperimentalFeature('SHOW_FREQUENT_PASSENGERS');
  const { frequentPassengers } = useSelector((state) => state.userPreferences.toJS());

  if (!showFrequentPassengers) {
    return { passengers: [] };
  }

  return {
    passengers: frequentPassengers?.passengers || [],
  };
};

export default useUserPreferences;
